import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const WrapperHeaderBlock = styled.div`
  width: 90%;
  max-width: 1400px;
  min-width: 320px;
  background-image: url(https://i.simpalsmedia.com/point.md/news/thumbnails/large/d4fc6069b303e191bdaf8f88ab9d64e1.webp);
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;

  @media (max-width: 1035px) {
  }
`;